export default __webpack_public_path__ + "static/broadcastImg7-fed7509d84927021b7710f3bbdf200fa.webp";